import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { config } from '../../../../config';
import './TimeElapsed.scss';

export const TimeElapsed = () => {
    const { paymentRequest: {status, createTime} = {} } = useSelector(({app}) => app);
 
    const timer = useRef();
    const [leftTime, setLeftTime] = useState(0);
    
    const getClockTime = () => {
        const minutes = Math.floor(leftTime / 60);
        let seconds = (leftTime - minutes * 60);
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    } 

    useEffect(() => {
        const _leftTime =  Date.now() - new Date(createTime).getTime();

        if(_leftTime > 0 && status === config.statuses.payment_sent){
            setLeftTime(Math.floor(_leftTime/1000));
        }

        timer.current = setInterval(() => {
            setLeftTime(prev => {
                if(prev <= 0) clearInterval(timer.current);
                return prev > 0 ? prev + 1 : 0;
            })
        }, 1000);

        return () => {
            clearInterval(timer.current);
        }
        //eslint-disable-next-line
    }, []);

    return (
        <div className={`time-elapsed-component`}>
            <div className="time-elapsed-component__inner">
                <h2>Time elapsed</h2>
                <p><img src={require('../../../../images/timer-icon.svg')} alt="timer" /> <span>{getClockTime()}</span></p>
            </div>
        </div>
    )
}

export default TimeElapsed;